import React from "react";
import PropTypes from "prop-types";
import GoalListItem from "../goalListItem/goalListItem";
import SectionToggle from "../sectionToggle/sectionToggle";
import MultiSelectDropdown from "../multiSelectDropdown/multiSelectDropdown";
import { formatGoalTitle } from "../../utils/formatters";

export default class GoalsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 700,
      activeHeight: 0,
      numGoalsActive: 0,
      selectedMetrics: [],
      selectedLocations: [],
      selectedDisplayed: [],
      noRender: false,
      maxDisplay: 100000,
      loadingMore: false
    };
  }

  submitGoal(id, value, active) {
    this.props.saveGoal(id, value, active);
  }

  submitGoalAsValue(id, value, active) {
    this.props.saveGoalAsValue(id, value, active);
  }

  getValues = (data, valueName) => {
    const locations = [];
    data.forEach((value, index) => {
      const title = valueName === "title" ? formatGoalTitle(value[valueName]) : value[valueName];
      if (index < this.state.maxDisplay && !locations.includes(title)) {
        locations.push(title);
      }
    });
    return locations;
  };

  formatClass(name) {
    //console.log("name:", name);
    name = name.replace(/\s+/g, "-").toLowerCase();
    return name;
  }

  componentDidMount() {
    this.onSelectChange();
  }

  onSelectChange() {
    // get all goals
    const goals = document.querySelectorAll(`.${this.props.customClass} .goal-list-wrapper`);

    let filteredLocations = [];
    let selectedMetricsAndLocations = [];
    let selectedMetricsAndLocationsAndDisplayed = [];
    // remove display for all goals
    for (var i = 0; i < goals.length; i++) {
      goals[i].classList.remove("show");
    }

    setTimeout(() => {
      [...goals].map((item) => {
        this.state.selectedLocations.map((loc) => {
          if (item.classList.contains(this.formatClass(loc))) {
            filteredLocations.push(item);
          }
        });
      });
      [...filteredLocations].map((item) => {
        this.state.selectedMetrics.map((metric) => {
          if (item.classList.contains(this.formatClass(metric))) {
            selectedMetricsAndLocations.push(item);
          }
        });
      });
      [...selectedMetricsAndLocations].map((item) => {
        this.state.selectedDisplayed.map((displayed) => {
          if (item.classList.contains(this.formatClass(displayed))) {
            selectedMetricsAndLocationsAndDisplayed.push(item);
          }
        });
      });

      [...selectedMetricsAndLocationsAndDisplayed].map((item) => {
        item.classList.add("show");
      });
    }, 100);
  }

  UNSAFE_componentWillMount() {
    if (this.props.goalData === null) {
      this.setState({
        noRender: true
      });
    } else {
      this.setState({
        selectedLocations: this.getValues(this.props.goalData, "locationName").slice(0, 5),
        selectedMetrics: this.getValues(this.props.goalData, "title"),
        selectedDisplayed: ["ACTIVE", "INACTIVE"]
      });
    }
  }

  render() {
    return (
      <div style={{ marginTop: "7px" }}>
        {!this.state.noRender ? (
          <SectionToggle
            title={this.props.title}
            customClass={this.props.customClass}
            autoHeight
            content={
              <div className="goals-list-wrapper">
                <div className="row-headers">
                  {!this.props.currentUser.singleLocation ? (
                    <div className="region">
                      <p>Location</p>
                      {!this.state.loadingMore ? (
                        <MultiSelectDropdown
                          options={this.getValues(this.props.goalData, "locationName")}
                          placeholder="Site"
                          enableOnly
                          numberDisplayed={0}
                          includeSelectAll
                          enableDefaultSelected
                          defaultSelected
                          defaultSelectedNumber={5}
                          haveOnSelectChange
                          onSelectChange={(val) => (
                            this.setState({ selectedLocations: val }),
                            this.onSelectChange(val, "location")
                          )}
                        />
                      ) : null}
                    </div>
                  ) : null}
                  <div className="site">
                    <p>Metric</p>
                    {!this.state.loadingMore ? (
                      <MultiSelectDropdown
                        options={this.getValues(this.props.goalData, "title")}
                        placeholder="Goal"
                        enableOnly
                        numberDisplayed={0}
                        selectAll
                        includeSelectAll
                        haveOnSelectChange
                        onSelectChange={(val) => (
                          this.setState({ selectedMetrics: val }), this.onSelectChange(val, "goal")
                        )}
                      />
                    ) : null}
                  </div>
                  <p className="goal">Increase</p>
                  <p className="goal-value">Goal</p>
                  <p className="current">Current</p>
                  <p className="forecast">Forecast</p>
                  <p className="needed">Needed</p>
                  <p className="pacing">Progress</p>
                  <div className="show-goal">
                    <p>Display</p>
                    {!this.state.loadingMore ? (
                      <MultiSelectDropdown
                        options={["ACTIVE", "INACTIVE"]}
                        placeholder="Show Goal"
                        selectAll
                        includeSelectAll
                        numberDisplayed={2}
                        enableOnly
                        haveOnSelectChange
                        onSelectChange={(val) => (
                          this.setState({ selectedDisplayed: val }),
                          this.onSelectChange(val, "display")
                        )}
                      />
                    ) : null}
                  </div>
                </div>
                <div>
                  {this.props.goalData.map((value, index) => {
                    return (
                      <span key={value.id}>
                        <GoalListItem
                          isAnimated={this.props.isAnimated}
                          id={value.id}
                          currentUser={this.props.currentUser}
                          metricName={this.props.title}
                          locationName={this.props.goalData[index].locationName}
                          goalName={this.props.goalData[index].title}
                          saveGoal={(id, goalValue, active) =>
                            this.submitGoal(id, goalValue, active)
                          }
                          saveGoalAsValue={(id, goalValue, active) =>
                            this.submitGoalAsValue(id, goalValue, active)
                          }
                          goalData={this.props.goalData[index]}
                          index={this.props.title + index.toString()}
                        />
                      </span>
                    );
                  })}
                </div>
              </div>
            }
          />
        ) : null}
      </div>
    );
  }
}

GoalsList.propTypes = {
  goalData: PropTypes.array,
  listHeight: PropTypes.number,
  expandedHeight: PropTypes.number,
  title: PropTypes.string,
  saveGoal: PropTypes.func.isRequired,
  saveGoalAsValue: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  customClass: PropTypes.string,
  isAnimated: PropTypes.bool
};
